import { GameVisuals } from "../../../gql/graphql";
import { Cell } from "./Cell";
import { Row } from "./Row";

type EmptyRowProps = {
  length: number;
  theme: GameVisuals;
};

export const EmptyRow = ({ length, theme }: EmptyRowProps) => {
  const emptyCells = Array.from(Array(length));

  return (
    <Row>
      {emptyCells.map((_, i) => (
        <Cell key={i} theme={theme} />
      ))}
    </Row>
  );
};
